
import Vue from 'vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XButton from 'vux/src/components/x-button/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import InlineXSwitch from 'vux/src/components/inline-x-switch/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'

var OutTimePage = Vue.extend({})
Vue.component('outTime-page', OutTimePage)

export default {
name: 'OutTimePage',
components: {
XTable,
Selector,
CheckIcon,
Flexbox,
FlexboxItem,
XInput,
XTextarea,
Group,
CellBox,
PopupHeader,
Popup,
XSwitch,
Radio,
XButton,
XDialog,
InlineXSwitch,
Scroller,
Divider,
LoadMore,
},
directives: {
TransferDom
},
data () {
return {
baseUrl: this.$store.state.url,
flowId: '',
info: {},
applyStaffName:'',
departmentName:'',
applyStaffRank:'',
outTimeData: {},
outTimeTypeList: [],
outTimeType: '',
outTimeTypeLabel: '',
outTimeTypeFlag: false,
startDate: '',
endDate: '',
nowDate: '',
dateDiffer: '',
outtimeDay:'',
overtimeTimes:'', //本月外出次数
projectOrder:'', //项目指令号
areaName:'', //外出地点
outtimeReason:'',  //外出原因
connectionMode:'', //外出联系方式
remark:'',
contactInformation: '',
fileShowList: [], // 上传附件集合-预览
uploadedFileIdList: [], // 已上传附件ID集合
countOvertimeDays: {},

showToast: false,//所属项目-dialog
projectName: '',//dialog-项目名称
projectList: [],//dialog-项目搜索结果
projectNameList: [],//dialog-项目搜索结果
projectAllNum: '',//dialog-项目总个数
projectChoosed: {
projectName:''
},//dialog-选择的项目
pageNum: 1,//dialog-项目搜索结果-页码
switchValue: false,//dialog-选择项目switch
preStatus: true,
nextStatus: false,
}
},
mounted () {
this.$emit('sendTitleToParent','外出申请');
this.getOutTimeTypeList()
this.getOutTimeData()
},
props: {
saveStatus: Number
},
methods: {
async getOutTimeData () {
let res = await this.axios({
url: this.baseUrl + '/wechat/outtime/outtimeApply',
method: 'get'
})
this.info = res.data.form
console.log(this.info)
this.outtimeData = res.data
},
async getOutTimeTypeList () {
let res = await this.axios({
url: this.baseUrl + '/wechat/commonInterface/listBaseDatas2/OUTGOING_TYPE',
method: 'get'
})
res.data.list.forEach((item) => {
item.key = item.id
item.value = item.name
this.outTimeTypeList.push(item)
})
},
getOutTimeType (value, label) {
this.outTimeType = value;
this.outTimeTypeLabel = label;
this.outTimeTypeFlag = false;
},
selectOutTimeType () {
this.outTimeTypeFlag = true;
},
click5 (key, item) {
console.log(key, item)
},
chooseStartDate () {
let that = this
this.$vux.datetime.show({
cancelText: '取消',
confirmText: '确定',
format: 'YYYY-MM-DD HH:mm',
minuteList: ['00', '15', '30', '45'],
endDate: this.endDate,
value: this.startDate,
onConfirm (val) {
that.startDate = val
that.getDateDiffer()
}
})
},
chooseEndDate () {
let that = this
this.$vux.datetime.show({
cancelText: '取消',
confirmText: '确定',
format: 'YYYY-MM-DD HH:mm',
value: this.endDate,
minuteList: ['00', '15', '30', '45'],
startDate: this.startDate,
onConfirm (val) {
that.endDate = val
that.getDateDiffer()
}
})
},
async getDateDiffer () {
if (this.startDate != '' && this.endDate != '') {
let res = await this.axios({
url: this.baseUrl + '/wechat/outtime/countOutTimeDays?startTime=' + this.startDate + '&endTime=' + this.endDate,
method: 'get'
})
if (res.data.status) {
this.dateDiffer = res.data.overtimeDay + '天 ' + res.data.overtimehour + '小时  共计' + res.data.overtimeCountHour + '小时'
this.countOvertimeDays = res.data
console.log(this.countOvertimeDays)
}
}
},
async openDialog () {// 打开选择项目-dialog
this.showToast = true;
this.$vux.loading.show({
text: '加载中'
});
let res = await this.axios({
url: this.baseUrl+'/wechat/commonInterface/getAllProject',
method: 'get'
});
this.searchProject();
},
async searchProject () {// dialog-搜索项目
this.projectList = [];
let res = await this.axios({
url: this.baseUrl+'/wechat/commonInterface/getAllProject?projectName='+this.projectName+'&page='+this.pageNum+'&rows=15',
method: 'get'
});
this.$vux.loading.hide();
this.projectList = res.data.list;
let projectLength = res.data.list.length;
for(let i=0;i<projectLength;i++){
this.projectNameList.push(res.data.list[i].projectName);
}
this.projectAllNum = Math.ceil(res.data.total/15);
},
getPrePage () {//dialog-上一页
if(this.pageNum == 1){
this.preStatus = true;
}else{
this.projectChoosed = {};
this.nextStatus = false;
this.pageNum--;
this.searchProject();
}
},
getNextPage () {//dialog-下一页
if(this.pageNum == this.projectAllNum){
this.nextStatus = true;
}else{
this.projectChoosed = {};
this.preStatus = false;
this.pageNum++;
this.searchProject();
}
},
chooseProject () {//dialog-确定
this.showToast = false;
},
clearProject () {// 清除业务
this.projectChoosed = {};
},

chooseFile () { // 选择附件
this.fileObj = document.getElementById('file').files;
this.$vux.loading.show({
text: '保存中'
})
this.submitFile();
},
deleteFile (index) { // 删除已选附件
this.fileShowList.splice(index, 1)

let deleteFileId = this.uploadedFileIdList[index]
let fileData = new FormData()
fileData.append('fileId', deleteFileId)
this.$vux.loading.show({
text: '删除中'
});
this.axios({
url: this.baseUrl + '/wechat/commonFile/deleteFile',
method: 'post',
data: fileData
}).then((response) => {
this.$vux.loading.hide();
this.uploadedFileIdList.splice(index, 1)
}).catch((response) => {
this.$vux.loading.hide()
})
},
async submitFile () { // 上传附件-图片
let fileObjL = this.fileObj.length;
for (let i = 0; i < fileObjL; i++) {
let fileData = new FormData()
fileData.append('file', this.fileObj[i])
fileData.append('taskId', this.info.id)
fileData.append('refRecordId', this.outtimeData.refRecordId)
fileData.append('refModule', this.outtimeData.refModule)
let res = await this.axios({
url: this.baseUrl + '/wechat/commonFile/uploadFile',
method: 'post',
data: fileData
})
this.uploadedFileIdList.push(res.data.fileId)

let that = this
let file = this.fileObj[i]
let reader = new FileReader()
reader.readAsDataURL(file)
reader.onload = function (e) {
that.fileShowList.push(this.result)
}
}

this.$vux.loading.hide()
},

showMsg (msg) {
this.$vux.alert.show({
title: msg
})
setTimeout(() => {
this.$vux.alert.hide()
}, 2000)
},
saveForm () { // 保存
if (this.outTimeType == '' || this.startDate == '' || this.endDate == '' || this.outtimeReason == '' || this.connectionMode == '') {
this.showMsg('请补充必填信息')
return false
}
this.$vux.loading.show({
text: '加载中'
})
let formData = new FormData()
formData.append('id', this.info.id)
formData.append('startTime', this.startDate)
formData.append('endTime', this.endDate)
formData.append('outtimeDay', this.countOvertimeDays.overtimeDay)
formData.append('outtimeHour', this.countOvertimeDays.overtimehour)
formData.append('overtimeCountHour', this.countOvertimeDays.overtimeCountHour)
formData.append('projectOrder', this.projectOrder)
formData.append("projectName",this.projectChoosed.projectName);
formData.append('outGoingType', this.outTimeType)
formData.append('areaName', this.areaName)
formData.append('outtimeReason', this.outtimeReason)
formData.append('connectionMode', this.connectionMode)
this.axios({
url: this.baseUrl + '/wechat/outtime',
method: 'post',
data: formData
}).then((response) => {
if (response.data.status == 0) { // 保存失败
console.log('保存失败')
this.$vux.loading.hide()
this.showMsg(response.data.msg)
} else if (this.saveStatus == 0 && response.data.status == 1) { // 父组件操作发起，并且保存成功
console.log('startFlow')
this.startFlow()
} else if (this.saveStatus == 1 && response.data.status == 1) { // 父组件操作提交，并且保存成功
console.log('$emit')
this.$emit('sendStatusToParent', {status: 1})
this.$vux.loading.hide()
}
}).catch((response) => {
this.$vux.loading.hide()
})
},
startFlow () { // 发起
let startData = new FormData()
startData.append('id', this.info.id);
this.axios({
url: this.baseUrl + '/wechat/outtime/startFlow',
method: 'post',
data: startData
}).then((response) => {
console.log('startFlow', response.data)
this.showMsg('保存成功！请继续完成提交操作！')

if (response.data.status == 1) {
this.$emit('sendStatusToParent', {
status: 0,
id: response.data.taskId,
stepId: response.data.stepId
})
}
this.$vux.loading.hide()
}).catch((response) => {
this.$vux.loading.hide()
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/launch/attendance/outTime.vue